import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PcdfSearchManual371Service } from 'src/rdsap/services/pcdf/pcdf-search-manual371.service';

@Component({
  selector: 'app-pcdb-manual-controls-table',
  templateUrl: './pcdb-manual-controls-table.component.html'
})
export class PcdbManualControlsTableComponent implements OnInit {
  result: any;
  selectedPcdbData: any[] = [];
  @Output() onSelectData = new EventEmitter<any>(); 
  @Input() headers = [
    { key: 'brandName', label: 'Brand name' },
    { key: 'modelName', label: 'Model name' },
    { key: 'modelQualifier', label: 'Model Qualifier' },
    { key: 'select', label: 'Select' },
  ];

  constructor(private pcdfSearchManual371Service: PcdfSearchManual371Service) {}

  ngOnInit(): void {
    this.result = this.pcdfSearchManual371Service.viewPcdbControlsHeatersData();
  }

  selectPcdbData(data) {
    const checked = data.selected;
    const existData = this.selectedPcdbData.findIndex(item => item.indexNumber === data.id);
    if(checked && existData < 0) {
        this.selectedPcdbData = [...this.selectedPcdbData, {
          indexNumber: data.id,
        }];
    } else if(!checked && existData >= 0) {
      this.selectedPcdbData.splice(existData, 1);
    } else if(checked && existData >= 0) {
      this.selectedPcdbData[existData] = {
        indexNumber: data.id,
      };
    }
    this.onSelectData.emit(this.selectedPcdbData);
  }
}
